import { useNavigate } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/constants/images";
import { useSite } from "@/context/SiteContext";

const VALUES = [
  { title: "Amanah", desc: "Menjaga kepercayaan jamaah dalam pengelolaan data dan biaya." },
  { title: "Profesional", desc: "Menjalankan pembinaan dengan standar dan metode yang teruji." },
  { title: "Ikhlas", desc: "Melayani setiap jamaah dengan ketulusan hati." },
];

export default function TentangKami() {
  const navigate = useNavigate();
  const { settings } = useSite();

  return (
    <div data-testid="tentang-kami-page">
      <section className="relative flex min-h-[45vh] items-center overflow-hidden">
        <img src={settings.about_hero_image || IMAGES.islamicArchitecture} alt="Tentang KBIHU Muhammadiyah Surabaya" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#084C3A]/95 to-[#0F6B4F]/50" />
        <div className="relative mx-auto max-w-4xl px-4 py-24 text-center sm:px-6">
          <h1 data-testid="tentang-kami-hero-title" className="font-heading text-4xl font-bold text-white sm:text-5xl">{settings.about_hero_title}</h1>
          <p data-testid="tentang-kami-hero-subtitle" className="mt-4 text-lg text-white/85">{settings.about_hero_subtitle}</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <img src={settings.about_history_image || IMAGES.pilgrimsCommunity} alt="Sejarah KBIHU Muhammadiyah Surabaya" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-lg" />
          <div>
            <span className="text-sm font-semibold uppercase tracking-wide text-[#1677B8]">Sejarah</span>
            <h2 data-testid="tentang-kami-history-title" className="mt-3 font-heading text-3xl font-bold text-[#1F2937]">{settings.about_history_title}</h2>
            {(settings.about_history_content || "").split("\n\n").map((para, i) => (
              <p key={i} className="mt-5 text-base leading-relaxed text-[#64748B]" data-testid={`tentang-kami-history-paragraph-${i}`}>{para}</p>
            ))}
          </div>
        </div>

        <div className="mt-20 grid grid-cols-1 gap-6 sm:grid-cols-2">
          <div className="rounded-2xl bg-[#F5F9F7] p-8">
            <h3 className="font-heading text-xl font-bold text-[#0F6B4F]">Visi</h3>
            <p data-testid="tentang-kami-vision" className="mt-3 text-sm leading-relaxed text-[#64748B]">{settings.about_vision}</p>
          </div>
          <div className="rounded-2xl bg-[#F5F9F7] p-8">
            <h3 className="font-heading text-xl font-bold text-[#0F6B4F]">Misi</h3>
            <p data-testid="tentang-kami-mission" className="mt-3 text-sm leading-relaxed text-[#64748B]">{settings.about_mission}</p>
          </div>
        </div>

        <div className="mt-20">
          <h3 className="text-center font-heading text-2xl font-bold text-[#1F2937]">Nilai-Nilai Kami</h3>
          <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-3">
            {VALUES.map((v) => (
              <div key={v.title} className="rounded-2xl bg-white p-6 text-center shadow-[0_2px_16px_rgba(15,107,79,0.06)]">
                <CheckCircle2 className="mx-auto h-8 w-8 text-[#0F6B4F]" />
                <h4 className="mt-3 font-heading font-semibold text-[#1F2937]">{v.title}</h4>
                <p className="mt-1 text-sm text-[#64748B]">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <Button data-testid="tentang-kami-register-cta" onClick={() => navigate("/register")} className="gap-2 rounded-full bg-gradient-to-r from-[#0F6B4F] to-[#1677B8] px-8 text-white hover:opacity-90">
            Daftar Sekarang <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </section>
    </div>
  );
}
